;+(function ($) {
    $(function() {
        $('.nav-item-link-arrow').on('click', function(event) {
            // event.stopPropagation()
            event.preventDefault()
            var $this = $(this)
            $this.closest('.header-nav-item.has-dropdown').toggleClass('action-hover')
            theme.defer.openPcMenuFn($this.closest('.header-nav-item.has-dropdown'))
            loadMenuRes($this.closest('.header-nav-item.has-dropdown'))
        }) 
          $('.header-nav-item .header-nav-item-link-click').on('click', function(event) {
            // event.stopPropagation()
            // event.preventDefault()
            
            var $this = $(this)
            $('.header-nav-item.has-dropdown').removeClass('action-hover')
            $this.closest('.header-nav-item.has-dropdown').toggleClass('action-hover')
            theme.defer.openPcMenuFn($this.closest('.header-nav-item.has-dropdown'))
            loadMenuRes($this.closest('.header-nav-item.has-dropdown'))
        })     
        $('.site-header--inline .header-nav-item.has-dropdown').hoverIntent({
            over: function(event) {
              event.stopPropagation();
              hideSearch();
              $(this).addClass("action-hover");
              //$(this).find('.menus-v2-text-version')[0].getBoundingClientRect().width
              let menuTextVersionContainer =$(this).find(".menus-v2-text-version")
              if (menuTextVersionContainer.length>0)
                $(this)
                  .find(".inline-dropdown.inline-dropdown-collection.is_text_menu_v2 .header-inline-nav-bottom .page-width")
                  .css(
                    "max-width",
                    menuTextVersionContainer[0].getBoundingClientRect().width +
                      "px"
                  );
              theme.defer.openPcMenuFn($(this));
              loadMenuRes(this);
              // $('#globalnavVisible').show()
              $("#tolstoyWidgetElement").hide();
            },
            out: function(event) {
                event.stopPropagation()
                $(this).removeClass('action-hover')
                if (!$('.header-nav-item.action-hover').length) {
                    // $('#globalnavVisible').hide()
                    $('#tolstoyWidgetElement').show()
                }
            },
            interval: 35,
            timeout: 250,
            sensitivity: 3
        })
        $('.inline-dropdown-menu-tab-item').on('mouseenter', function(event) {
            event.stopPropagation()
            var $con = $(this).closest('.inline-dropdown')
            $con.find('.inline-dropdown-menu-tab-item, .dropdown-menu-tab-content').removeClass('active')
            $(this).addClass('active')
            $('#' + $(this).data('target')).addClass('active')
            if ($('#' + $(this).data('target') + '-bottom').length) {
                $con.find('.header-inline-nav-bottom ').addClass('hide')
                $('#' + $(this).data('target') + '-bottom').removeClass('hide')
            }
        })
        // $('.site-header--inline .header-nav-item.has-dropdown').off('mouseenter mouseleave')

        function hideDropdown() {
            if ($('.header-nav-item.action-hover').length) {
                $('.header-nav-item').removeClass('action-hover')
            }
        }

        function hideSearch() {
            if ($('.js-search-trigger').hasClass('active')) {
                $('.js-search-trigger').removeClass('active')
                $('.search-container').removeClass('focused')
            }
        }

        function hidePredictiveSearch() {
          if ($('.predictive-search-layout').length) {
            $('.predictive-search-layout').css('opacity', '')
            setTimeout(() => {
              $('.site-header-predictive-search').removeClass('active')
            }, 300)
            $('.site-header-predictive-search input[name=q]').blur()
          }
        }

        window.on('scroll', function() {
            hideDropdown()
            hideSearch()
            hidePredictiveSearch()
        })

        $('.js-search-trigger').each(function() {
            $(document.body).on('click', function(e) {
                if ($('.search-container').hasClass('focused')) {
                    if (!$.contains($('.search-container')[0], e.target) && !$.contains($('.js-search-trigger')[0], e.target)) {
                        hideSearch()
                        // $('#globalnavVisible').hide()
                    }
                }
                if ($('.site-header-predictive-search').hasClass('active')) {
                  if (!$.contains($('.site-header-predictive-search')[0], e.target)) {
                        hidePredictiveSearch()
                    }
                }
            })
            $(this).on('click', function(e) {
                e.preventDefault()
                if ($(this).hasClass('active')) {
                    hideSearch()
                    // $('#globalnavVisible').hide()
                } else {
                    $(this).addClass('active')
                    $('.search-container').addClass('focused')
                   
                    setTimeout(()=>{
                        Array.from($('.search-form-item input[name=q]')).map(ele => {
                            ele.focus()
                        });
                    },100)
                    // $('#globalnavVisible').show()
                }
            })
           
        })

        function loadMenuRes(ele) {
            $(ele).closest('li').find('.vego-menudrop-combination-content-svg').each((index, item) => {
                if ($(item).css('background-image') === 'none') {
                $(item).css('background-image', `url(${$(item).data().bg})`)
                }
            })
            //lazyload menu icon
            if (!$(ele).data('loadedMenuResource') && $(ele).hasClass('header-nav-item-garden-beds')) {
                $(ele).data('loadedMenuResource', true)
                theme.initMenuIcon()
            }
        }

        theme.initSearchEvents()
    })
})(jQuery)